
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"8","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.39 4.047l1.532-.625.125-.555c.094-.453.14-.77.14-.953 0-.219-.067-.372-.203-.46-.13-.09-.367-.139-.71-.15l.093-.406 1.977-.07h.453l-.5 2.016 1.976-.852.282.633-2.461 1.031-.64 2.586.093.031c.49-.65.956-1.125 1.398-1.421.443-.297.894-.446 1.352-.446.49 0 .864.138 1.125.414.266.276.398.664.398 1.164 0 .329-.075.795-.226 1.399L6.086 9.43c-.14.567-.211.968-.211 1.203 0 .208.034.36.102.453.067.094.174.14.32.14.156 0 .323-.062.5-.187.177-.13.427-.375.75-.734l.445.437c-.422.438-.745.742-.969.914a2.2 2.2 0 01-.648.36c-.203.072-.435.109-.695.109-.339 0-.61-.12-.813-.36-.203-.244-.304-.554-.304-.93 0-.338.085-.835.257-1.491l.344-1.352c.125-.49.206-.851.242-1.086.042-.234.063-.424.063-.57 0-.365-.063-.625-.188-.781-.12-.157-.317-.235-.593-.235-.22 0-.461.089-.727.266-.26.177-.534.448-.82.812-.287.36-.516.706-.688 1.04-.167.328-.3.72-.398 1.18L1.344 12H-.008l1.75-7.781-1.07.46-.281-.632z","fill":"currentColor"}})])
          )
        }
      }
    